import $ from "jquery";

export const init = () => {
  $(".scrollto").on("click", function (e) {
    e.preventDefault();
    let href = $(this).attr("href");
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $(href).offset().top - 50,
        },
        1000
      );
  });
};
